import { makeStyles } from "@material-ui/core";
import { color } from "../../../assets/const/color";

export const useStyles = makeStyles(() => ({
  attendance: {
    flexDirection: "column !important",
    "& .MuiInputBase-root": {
      borderRadius: "40px",
      fontFamily: "inter !important",
    },
    "& .MuiButton-root:hover": {
      background: `${color.lightGreen} !important`,
      color: `${color.white} !important`,
    },
    "& .MuiCheckbox-colorPrimary.Mui-checked": {
      color: `${color.gray} !important`,
      borderRadius: "50px !important",
    },
    "& .MuiCheckbox-root.MuiCheckbox-indeterminate": {
      color: `${color.gray} !important`,
    },
    "& .MuiTableHead-root": {
      "& .MuiTableCell-root": {
        background: "#FEB62C",
        color: `${color.white} !important`,
        fontFamily: "inter",
      },
      "& :first-child": {
        borderRadius: "10px 0px 0px 0px !important",
      },
      "& :last-child": {
        borderRadius: "0px 10px 0px 0px !important",
      },
    },
    "& .MuiTableRow-root .MuiTableCell-root": {
      fontFamily: "inter !important",
    },
    "& p": {
      fontFamily: "inter",
    },
  },
  // align: {
  //     marginLeft:"30px",
  // },
  backArrow: {
    cursor: "pointer",
    fontFamily: "inter !important",
    color: `${color.black}`,
    fontSize: "16px",
  },
  title: {
    fontFamily: "inter !important",
    color: `${color.darkGreen}`,
    fontSize: "18px",
    fontWeight: 700,
  },
  error: {
    color: "red",
    fontSize: "12px",
  },
  input_label: {
    fontFamily: "inter !important",
    fontSize: "18px !important",
    color: "#222222",
  },
  search_btn: {
    marginLeft: "10px",
    textTransform: "capitalize !important",
    fontFamily: "inter !important",
    color: `${color.white} !important`,
    background: `${color.lightGreen} !important`,
  },
  textgap: {
    marginRight: "10px",
    marginLeft: "10px",
  },
  student_attendance_text: {
    textTransform: "capitalize !important",
    fontFamily: "inter !important",
    color: `${color.black} !important`,
    fontSize: "20px",
    marginBottom: "8px",
  },
  student_attendance_percentage_text: {
    textTransform: "capitalize !important",
    fontFamily: "inter !important",
    color: `green !important`,
    paddingLeft: "4px",
    fontWeight: 700,
  },
  form_add_course: {
    "& .MuiInputBase-root": {
      borderRadius: "50px",
      fontFamily: "inter !important",
    },
    "& .MuiButton-root:hover": {
      background: `${color.lightGreen} !important`,
      color: `${color.white} !important`,
    },
  },
  imggap: {
    marginRight: "10px",
    marginBottom: "10px",
  },
  attendanceForm: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: "16px",
  },

  tabs: {
    backgroundColor: "lightblue",
    textAlign: "center",
    "&.MuiTab-root": {
      justifyItems: "center",
      justifyContent: "center !important",
    },
  },
  tab: {
    color: "white",
    fontWeight: "bold",
  },
}));
